import { useState, useEffect } from "react";
import "./VacanciesUkraine.scss";
import { CountryVacanciesComponent_Plain } from "../../../types/components/page/CountryVacanciesComponent.ts";
import { Vacancy_Plain } from "../../../types/api/vacancy.ts";
import { useTranslation } from "react-i18next";

const VacanciesUkraine = ({
  data,
  title,
}: {
  data: CountryVacanciesComponent_Plain[];
  title: string;
}) => {
  const { t } = useTranslation();
  const [activeTab] = useState(0);
  const [isOpen] = useState(false);

  const [openedVacancies, setOpenedVacancies] = useState<boolean[]>([]);

  useEffect(() => {
    if (data && data.length > 0 && data[activeTab]) {
      updateTitle(data[activeTab].title);
      setOpenedVacancies(
        new Array(data[activeTab].vacancies.length).fill(false),
      );
    }
  }, [activeTab, data]);

  const updateTitle = (title: string) => {
    const titleElement = document.querySelector(".tabs-nav__title");
    if (titleElement) {
      titleElement.innerHTML = `${title}:`;
    }
  };
  const handleDetailsToggle = (index: number) => {
    setOpenedVacancies((prev) => {
      const newOpened = [...prev];
      newOpened[index] = !newOpened[index];
      return newOpened;
    });
  };

  return (
    <section className="vacancies vacancies--ukraine">
      <div className="wrapper">
        <div className="block-title">{title}</div>

        <div className={`tabs tabs-with-title ${isOpen ? "opened-tabs" : ""}`}>
          <div className="box-tabs-title">
            <div className="tabs-nav__title"></div>
          </div>
          <ul className="tabs-nav">
            {data.map((country, index) => (
              <li
                key={index}
                className={`tabs-nav__item ${activeTab === index ? "active" : ""}`}
              >
                <a href={`#${index}`}>{country.title}:</a>
              </li>
            ))}
          </ul>
          <div className="tabs-content">
            <div className="vacancies-list">
              {data[activeTab]?.vacancies.map(
                (vacancyItem: Vacancy_Plain, vacancyKey: number) => (
                  <div
                    key={vacancyKey}
                    className={`vacancies-list__item ${openedVacancies[vacancyKey] ? "opened" : ""}`}
                  >
                    <div className="vacancies-list__title">
                      <h2>{vacancyItem.vacancy.title}</h2>
                    </div>
                    <div className="vacancies-list__inf">
                      <div className="vacancies-tag">
                        {vacancyItem.vacancy.tags?.map((tag, index: number) => (
                          <div className="vacancies-tag__item" key={index}>
                            {tag.name}
                          </div>
                        ))}
                      </div>
                      <div
                        className="show-full"
                        onClick={() => handleDetailsToggle(vacancyKey)}
                      >
                        {openedVacancies[vacancyKey]
                          ? t("Hide details")
                          : t("See details")}
                      </div>
                      <div className="vacancies-list__cont">
                        <div className="vacancies-list__updated">
                          {vacancyItem.vacancy.updated ? (
                            <>
                              {t("Updated")}:{" "}
                              <span>{vacancyItem.vacancy.updated}</span>
                            </>
                          ) : (
                            ""
                          )}
                        </div>
                        <div className="vacancies-list__cont-text">
                          <p>{vacancyItem.vacancy.description}</p>
                        </div>
                        {vacancyItem.vacancy.link ? (
                          <a
                            className="btn-black"
                            href={vacancyItem.vacancy.link}
                            target={"_blank"}
                          >
                            {t("Apply for a job")}
                          </a>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  </div>
                ),
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default VacanciesUkraine;
